import React from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Modal, Row, Col, Icon, Spin, Popover } from 'antd';
const { Column } = Table;
import { getTaskExcuteResult,getTodyTaskData,getAgentMonitorData, getTaskMonitorData, getServiceMonitorData, clearListAction, clearOneListAction,getDiscardList, getNomalAgentConnInfo,getPhoneAgentConnInfo } from './actions';
import { connect } from 'react-redux';
import './style.scss';
import { toThousands } from '../../utils/';
import {todayTaskResult} from "./reducers";

class TaskMessageList extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        todayTaskTableData: '',
        yesTaskTableData: '',
        tomTaskTableData: '',
        activeKeys: '',
        dspActiveKeys:'',
        taskSource: 'normal',
        visible: false,
        ModalTitle: '',
        timeCurrentText: '',
        ModalAllData: [],
        isPopover: false,
        popoverHtml: '',
        content: '',
    };
    componentDidMount() {
        // this.props.getIndexList(); //查询操作日志
        // let getNineTimes = new Date(new Date().setHours(9, 0, 0, 0)).getTime();
        // let currentGetTimes = new Date().getTime();
        // console.log(getNineTimes,currentGetTimes)
        if (new Date().getHours() >= 9) {
            this.setState({
                activeKeys: 'get',
                dspActiveKeys:'get'
            });
        } else {
            this.setState({
                activeKeys: 'lt',
                dspActiveKeys:'lt'
            });
        }
        this.getTodayTasyData();
        this.props.getNomalAgentConnData();
        this.props.getPhoneAgentConnData();
        this.props.getAgentMonitorData();
        this.props.getTaskMonitorData();
        this.props.getServiceMonitorData();
        //this.props.getDiscardList();//废弃监控
        //this.props.getTaskExcuteResult();//首页任务执行情况
    }
    getTodayTasyData = () => {
        this.props.getTodyTaskData().then(() => {
            let { todyTaskData } = this.props;
            let todayEvTargetPv = todyTaskData.today.evTargetPv;
            let yesEvTargetPv = todyTaskData.yesterday.evTargetPv;
            let tomEvTargetPv = todyTaskData.tomorrow.evTargetPv;

            let todayClickTargetPv = todyTaskData.today.clickTargetPv;
            let yesClickTargetPv = todyTaskData.yesterday.clickTargetPv;
            let tomClickTargetPv = todyTaskData.tomorrow.clickTargetPv;

            let todayEvFinishedPv = todyTaskData.today.evFinishedPv;
            let yesEvFinishedPv = todyTaskData.yesterday.evFinishedPv;
            let tomEvFinishedPv = todyTaskData.tomorrow.evFinishedPv;

            let todayClickFinishedPv = todyTaskData.today.clickFinishedPv;
            let yesClickFinishedPv = todyTaskData.yesterday.clickFinishedPv;
            let tomClickFinishedPv = todyTaskData.tomorrow.clickFinishedPv;

            let todaygt90 = todyTaskData.today.gt90;
            let yesgt90 = todyTaskData.yesterday.gt90;
            let tomgt90 = todyTaskData.tomorrow.gt90;

            let todaylt90 = todyTaskData.today.lt90;
            let yeslt90 = todyTaskData.yesterday.lt90;
            let tomlt90 = todyTaskData.tomorrow.lt90;

            this.setState({
                todayTaskTableData: (
                    <tr style={{ height: '38px' }} id="today">
                        <td>今日</td>
                        <td>
                            {/* 添加上升下降状态显示 */}
                            {toThousands(todayEvTargetPv)}
                            {todayEvTargetPv !== yesEvTargetPv ? (
                                todayEvTargetPv > yesEvTargetPv ? (
                                    <Icon type="arrow-up" style={{ color: 'red', marginLeft: '5px' }} />
                                ) : (
                                    <Icon type="arrow-down" style={{ color: '#1ae41a', marginLeft: '5px' }} />
                                )
                            ) : (
                                <Icon type="minus" style={{ marginLeft: '5px', color: '#999' }} />
                            )}
                        </td>
                        <td>
                            {toThousands(todayClickTargetPv)}
                            {todayClickTargetPv !== yesClickTargetPv ? (
                                todayClickTargetPv > yesClickTargetPv ? (
                                    <Icon type="arrow-up" style={{ color: 'red', marginLeft: '5px' }} />
                                ) : (
                                    <Icon type="arrow-down" style={{ color: '#1ae41a', marginLeft: '5px' }} />
                                )
                            ) : (
                                <Icon type="minus" style={{ marginLeft: '5px', color: '#999' }} />
                            )}
                        </td>
                        <td>{toThousands(todayEvFinishedPv)}</td>
                        <td>{toThousands(todayClickFinishedPv)}</td>
                        <td>
                            {toThousands(todaygt90)}
                            {todaygt90 !== yesgt90 ? (
                                todaygt90 > yesgt90 ? (
                                    <Icon type="arrow-up" style={{ color: 'red', marginLeft: '5px' }} />
                                ) : (
                                    <Icon type="arrow-down" style={{ color: '#1ae41a', marginLeft: '5px' }} />
                                )
                            ) : (
                                <Icon type="minus" style={{ marginLeft: '5px', color: '#999' }} />
                            )}
                        </td>
                        <td>
                            {toThousands(todaylt90)}
                            {todaylt90 !== yeslt90 ? (
                                todaylt90 > yeslt90 ? (
                                    <Icon type="arrow-up" style={{ color: '#1ae41a', marginLeft: '5px' }} />
                                ) : (
                                    <Icon type="arrow-down" style={{ color: 'red', marginLeft: '5px' }} />
                                )
                            ) : (
                                <Icon type="minus" style={{ marginLeft: '5px', color: '#999' }} />
                            )}
                        </td>
                    </tr>
                ),
                yesTaskTableData: (
                    <tr style={{ height: '38px' }} id="yestoday">
                        <td>昨日</td>
                        <td>{toThousands(yesEvTargetPv)}</td>
                        <td>{toThousands(yesClickTargetPv)}</td>
                        <td>{toThousands(yesEvFinishedPv)}</td>
                        <td>{toThousands(yesClickFinishedPv)}</td>
                        <td>{toThousands(yesgt90)}</td>
                        <td>{toThousands(yeslt90)}</td>
                    </tr>
                ),
                tomTaskTableData: (
                    <tr style={{ height: '38px' }} id="tomorrow">
                        <td>明日</td>
                        <td>{toThousands(tomEvTargetPv)}</td>
                        <td>{toThousands(tomClickTargetPv)}</td>
                        <td>{toThousands(tomEvFinishedPv)}</td>
                        <td>{toThousands(tomClickFinishedPv)}</td>
                        <td>{toThousands(tomgt90)}</td>
                        <td>{toThousands(tomlt90)}</td>
                    </tr>
                ),
            });
        });
    }
    reloadServeData = () => {
        this.props.getServiceMonitorData();
    }
    ClicksLt = () => {
        this.setState({
            activeKeys: 'lt',
        });
    };
    ClicksGet = () => {
        this.setState({
            activeKeys: 'get',
        });
    };
    ClicksDspLt = () => {
        this.setState({
            dspActiveKeys: 'lt',
        });
    };
    ClicksDspGet = () => {
        this.setState({
            dspActiveKeys: 'get',
        });
    };
    ClicksNormal = () => {
        this.setState({
            taskSource: 'normal',
        });
    };
    ClicksAccurateOperations = () => {
        this.setState({
            taskSource: 'accurateOperations',
        });
    };
    ApplaunchAndCombine = () =>{
        this.setState({
            taskSource: 'applunch',
        });
    }
    // reload taskData
    reloadTaskData = () => {
        this.props.getTaskMonitorData();
    };

    renderNoGoalsRatesBtm5lt900 = (text, record, index) => (
        <span style={{ color: text < -0.1 ? 'red' : '' }}>{(text /1000.0).toFixed(2)}</span>
    );
    renderNoGoalsRatesTop5lt900 = (text, record, index) => (
        <span style={{ color: text > 0.1 ? 'red' : '' }}>{(text /1000.0).toFixed(2)}</span>
    );

    renderExecSucceedRatesBtm5lt900 = (text, record, index) => (
        <span style={{ color: text < 0.7 ? 'red' : '' }}>{(text * 100).toFixed(2) + '%'}</span>
    );
    renderExecSucceedRatesTop5lt900 = (text, record, index) => (
        <span style={{ color: text > 1 ? 'red' : '' }}>{(text * 100).toFixed(2) + '%'}</span>
    );

    // 取两位小数，加%
    renderCompleteRatesBtm5lt900 = (text, record, index) => <span>{(text * 100).toFixed(2) + '%'}</span>;

    //代理监控 加%
    renderAgentToFixed = (text, record, index) => text.toFixed(2) + '%';
    renderAgentMinotorErrorRate = (text, record, index) => (
        <span style={{ color: text > 30 ? 'red' : '' }}>{text.toFixed(2) + '%'}</span>
    );

    renderServiceStatus = (text, record, index) => (
        <Icon
            style={{ color: text === true ? 'green' : 'red', fontSize: '16px' }}
            type={text === true ? 'check-circle' : 'close-circle'}
        />
    );

     //任务实时监控 鼠标移入每一行展示当前数据详情
    renderTaskIds = (text, record) => {
        let content = (
            <div>
                <p>订单名称：{record.task.taskDescription}</p>
                <p>任务名称：{record.task.taskName}</p>
                <p>任务类型：{record.task.taskType}</p>
                <p>任务来源：{record.task.taskSource}</p>
            </div>
        );

        return (
            <Popover content={content} title="任务详情"  placement="top">
                <Link
                    to={`/statistics/task/${record.taskId}`}
                    style={{ color: record.taskAssignNum !== 0 && record.successCount === 0 ? 'red' : '#108ee9' }}>
                    {record.taskId}
                </Link>
            </Popover>
        );
    };
    renderTaskId = (text, record) => {
      let content = (
          <div>
              <p>订单名称：{record.taskDescription}</p>
              <p>任务名称：{record.taskName}</p>
              <p>任务类型：{record.taskType}</p>
              <p>任务来源：{record.taskSource}</p>
          </div>
      );

      return (
          <Popover content={content} title="任务详情"  placement="top">
              <Link
                  to={`/statistics/task/${record.taskId}`}
                  style={{ color: record.taskAssignNum !== 0 && record.successCount === 0 ? 'red' : '#108ee9' }}>
                  {record.taskId}
              </Link>
          </Popover>
      );
        // return (
        //     <Link
        //         to={`/statistics/task/${record.taskId}`}
        //         style={{ color: record.taskAssignNum !== 0 && record.successCount === 0 ? 'red' : '#108ee9' }}>
        //         {record.taskId}
        //     </Link>
        // );
    };
    //根据条件标红任务实时监控的某一行
    renderTaskMinotorTr = (record, index) => {
        if (record.taskAssignNum !== 0 && record.successCount === 0) {
            //className
            return 'trStyle';
        }
    };
    //控制展示执行情况全部数据的弹框
    showModal1 = () => {
      /*  if (this.state.activeKeys === 'lt') {
            this.setState({
                timeCurrentText: '9点前',
            });
            //点击时确定是哪一个模块的数据
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.noGoalsRateslt900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        } else {
            this.setState({
                timeCurrentText: '9点后',
            });
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.noGoalsRatesget900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        }
*/
      this.setState({
            timeCurrentText: 'averageStayTime',
        });
        if (this.props.todyTaskData.execInfos) {
            this.setState({
                ModalAllData: this.props.todayTaskResult.stayTime,
            });
        } else {
            this.setState({
                ModalAllData: [],
            });
        }

        this.setState({
            visible: true,
            ModalTitle: '停留时长',
        });
    };
    showModal2 = () => {
        //点击时确定当前是点在九点前还是九点后
        /*if (this.state.activeKeys === 'lt') {
            this.setState({
                timeCurrentText: '9点前',
            });
            //点击时确定是哪一个模块的数据
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.execSucceedRateslt900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        } else {
            this.setState({
                timeCurrentText: '9点后',
            });
            //点击时确定是哪一个模块的数据
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.execSucceedRatesget900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        }*/
        this.setState({
            timeCurrentText: 'arriveRatio',
        });
        //点击时确定是哪一个模块的数据
        if (this.props.todyTaskData.execInfos) {
            this.setState({
                ModalAllData: this.props.todayTaskResult.daoda,
            });
        } else {
            this.setState({
                ModalAllData: [],
            });
        }
        //显示modal和确定modal title
        this.setState({
            visible: true,
            ModalTitle: '任务到达率',
        });
    };
    showModal3 = () => {
        /*if (this.state.activeKeys === 'lt') {
            this.setState({
                timeCurrentText: '9点前',
            });
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.completeRateslt900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        } else {
            this.setState({
                timeCurrentText: '9点后',
            });
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.completeRatesget900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        }*/
        this.setState({
            timeCurrentText: 'tiaochuRatio',
        });
        //点击时确定是哪一个模块的数据
        if (this.props.todyTaskData.execInfos) {
            this.setState({
                ModalAllData: this.props.todayTaskResult.tiaochu,
            });
        } else {
            this.setState({
                ModalAllData: [],
            });
        }
        this.setState({
            visible: true,
            ModalTitle: '任务跳出率',
        });
    };

    // 控制展示执行情况全部数据的弹框
    showModalOne = () => {
        if (this.state.dspActiveKeys === 'lt') {
            this.setState({
                timeCurrentText: '9点前',
            });
            // 点击时确定是哪一个模块的数据
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.noGoalsOtherRateslt900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        } else {
            this.setState({
                timeCurrentText: '9点后',
            });
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.noGoalsOtherRatesget900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        }

        this.setState({
            visible: true,
            ModalTitle: '已超期望率',
        });
    };
    showModalTwo = () => {
        //点击时确定当前是点在九点前还是九点后
        if (this.state.dspActiveKeys === 'lt') {
            this.setState({
                timeCurrentText: '9点前',
            });
            //点击时确定是哪一个模块的数据
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.execSucceedOtherRateslt900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        } else {
            this.setState({
                timeCurrentText: '9点后',
            });
            //点击时确定是哪一个模块的数据
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.execSucceedOtherRatesget900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        }

        //显示modal和确定modal title
        this.setState({
            visible: true,
            ModalTitle: '执行成功率',
        });
    };
    showModalThree = () => {
        if (this.state.dspActiveKeys === 'lt') {
            this.setState({
                timeCurrentText: '9点前',
            });
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.completeOtherRateslt900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        } else {
            this.setState({
                timeCurrentText: '9点后',
            });
            if (this.props.todyTaskData.execInfos) {
                this.setState({
                    ModalAllData: this.props.todyTaskData.execInfos.completeOtherRatesget900,
                });
            } else {
                this.setState({
                    ModalAllData: [],
                });
            }
        }

        this.setState({
            visible: true,
            ModalTitle: '任务完成率',
        });
    };

    hideModal = () => {
        this.setState({
            visible: false,
        });
    };

    clearList = () => {
        this.props.clearListAction();
    };

    //clearOneList = (record) => {
    clearOneList(record) {
        console.log("ttt111");
        console.log(record);
        this.props.clearOneListAction(record.group,record.queueName);
    };

    render() {
        // let columns = [
        //     {
        //         title: '数据',
        //         dataIndex: 'index',
        //         render: (text, record) => <div>{record}</div>,
        //     },
        // ];
        const { loading, indexList, todyTaskData, PhoneAgentConnInfo,NomalAgentConnInfo,AgentMinotor, TaskMinotor, ServiceMinotor, taskLoading, serveLoading, discardMinotor } = this.props;
        return (
            <div style={{ padding: '24px 0', borderBottom: '1px solid #e8e8e8' }}>
                {/* 弹出层展示执行情况每一个模块的全部数据 */}
                <Modal
                    title={
                        <div>
                            <span style={{ fontSize: '16px', color: '#5c7db1', marginRight: '10px' }}>
                                {this.state.ModalTitle}
                            </span>
                            {/*<span
                                style={{
                                    marginRight: '10px',
                                    fontSize: '12px',
                                    background: '#5c7db1',
                                    color: '#fff',
                                    padding: '4px 6px',
                                    borderRadius: '5px',
                                }}>
                                {this.state.timeCurrentText}
                            </span>*/}全部数据详情(以"比率"升序排列)
                        </div>
                    }
                    visible={this.state.visible}
                    onCancel={this.hideModal}
                    footer={null}>
                    <Table
                        dataSource={this.state.ModalAllData}
                        pagination={false}
                        style={{ border: 'none' }}
                        scroll={{ y: 500 }}
                        size="small">
                        <Column
                            title="任务ID"
                            dataIndex="taskId"
                            key="taskId"
                            sorter={false}
                            width="50%"
                            render={this.renderTaskId}
                        />

                        <Column
                            title="停留时长"
                            dataIndex={this.state.timeCurrentText}
                            key={this.state.timeCurrentText}
                            width="50%"
                            sorter={false}
                            render={this.state.timeCurrentText == 'averageStayTime'?  this.renderNoGoalsRatesBtm5lt900 :(this.state.timeCurrentText=='arriveRatio'? this.renderExecSucceedRatesBtm5lt900 :this.renderCompleteRatesBtm5lt900)}
                        />
                    </Table>
                </Modal>
                <Spin spinning={loading} tip="加载中">
                    <div
                        id="tody_task"
                        style={{
                            border: '1px solid #e8e8e8',
                            boxShadow: '1px 2px 15px #ccc',
                            borderRadius: '5px',
                            overflow: 'hidden',
                        }}>
                        <h2
                            style={{
                                background: '#5c7db1',
                                padding: '10px 20px',
                                borderBottom: '1px solid #e8e8e8',
                                color: '#fff',
                            }}>
                            今日任务
                        </h2>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <tr
                                style={{
                                    height: '44px',
                                }}>
                                <th />
                                <th>曝光总任务量</th>
                                <th>点击总任务量</th>
                                <th>曝光已完成量</th>
                                <th>点击已完成量</th>
                                <th>9点后任务数</th>
                                <th>9点前任务数</th>
                            </tr>
                            {this.state.todayTaskTableData}
                            {this.state.yesTaskTableData}
                            {this.state.tomTaskTableData}
                        </table>
                    </div>
                </Spin>
                <div id="main_content" style={{ marginTop: '30px' }}>
                    <Row gutter={24}>
                        <Col span={8}>
                            <div id="left">
                                <div
                                    id="left_top"
                                    className="task_today"
                                    style={{
                                        height: 'auto',
                                        boxShadow: '1px 2px 15px #ccc',
                                        // borderRadius: '5px',
                                        overflow: 'hidden',
                                    }}>
                                    <Spin spinning={loading} tip="加载中">
                                        <div style={{boxShadow: '1px 2px 15px #ccc', borderRadius: '5px', overflow: 'hidden'}}>
                                            <h2 style={{ height: '47px', position: 'relative'}}>
                                                连接数统计
                                                <div style={{ right: '30px', position: 'absolute', top: '2px'}}>
                                                </div>
                                                <Icon
                                                    type="reload"
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontSize: '20px',
                                                        color: '#fff',
                                                        fontWeight: 'bold',
                                                        float: 'right',
                                                        marginTop: '4px',
                                                    }}
                                                    onClick={this.props.getNomalAgentConnData}
                                                />
                                            </h2>
                                            
                                            <div style={{ padding: '10px 10px 0' }}>
                                            <Table
                                            dataSource={NomalAgentConnInfo}
                                            pagination={false}
                                            size="small"
                                            scroll={{ y: 200 }}>
                                            <Column
                                                title="代理商"
                                                dataIndex="agentName"
                                                key="agentName"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />

                                            <Column
                                                title="总连接数"
                                                dataIndex="connectedNum"
                                                key="connectedNum"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />
                                            <Column
                                                title="最新连接数"
                                                dataIndex="lastConnectedNum"
                                                key="lastConnectedNum"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />
                                            <Column
                                                title="实时带宽/KB"
                                                dataIndex="widthSize"
                                                key="widthSize"
                                                sorter={false}
                                                width="20%"
                                                render={(text, record) => (
                                                    (text/1024).toFixed(0)
                                                )}
                                            />
                                            </Table>
                                            </div>
                                        </div>
                                    </Spin>

                                    <div
                                        id="left_bottom"
                                        style={{
                                            marginTop: '30px',
                                            boxShadow: '1px 2px 15px #ccc',
                                            borderRadius: '5px',
                                            overflow: 'hidden',
                                        }}>
                                        <h2>连接数统计/phone
                                        <div style={{ right: '30px', position: 'absolute', top: '2px'}}>
                                                </div>
                                                <Icon
                                                    type="reload"
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontSize: '20px',
                                                        color: '#fff',
                                                        fontWeight: 'bold',
                                                        float: 'right',
                                                        marginTop: '4px',
                                                    }}
                                                    onClick={this.props.getPhoneAgentConnData}
                                                />
                                        </h2>
                                        
                                        <Table
                                            dataSource={PhoneAgentConnInfo}
                                            pagination={false}
                                            size="small"
                                            scroll={{ y: 200 }}>
                                            <Column
                                                title="代理商"
                                                dataIndex="agentName"
                                                key="agentName"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />

                                            <Column
                                                title="最新连接数"
                                                dataIndex="lastConnectedNum"
                                                key="lastConnectedNum"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />
                                            <Column
                                                title="总连接数"
                                                dataIndex="connectedNum"
                                                key="connectedNum"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />
                                            <Column
                                                title="客户端数"
                                                dataIndex="clientCount"
                                                key="clientCount"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />
                                            <Column
                                                title="平均连接数"
                                                dataIndex="avg"
                                                key="avg"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />
                                        </Table>
                                    </div>
                                    {/* 间隔 */}

                                    {/* <div style={{marginTop: '30px',boxShadow: '1px 2px 15px #ccc', borderRadius: '5px', overflow: 'hidden'}}>
                                        <h2 style={{ position: 'relative' }}>
                                            执行情况(精投)
                                            <div
                                                className={this.state.dspActiveKeys === 'lt' ? 'active radio' : 'radio'}
                                                style={{ right: '89px', borderRadius: '4px 0 0 4px' }}
                                                onClick={this.ClicksDspLt}>
                                                9点前
                                            </div>
                                            <div
                                                className={this.state.dspActiveKeys === 'get' ? 'active radio' : 'radio'}
                                                style={{ right: '20px', borderRadius: '0 4px 4px 0' }}
                                                onClick={this.ClicksDspGet}>
                                                9点后
                                            </div>
                                        </h2>
                                        <div style={{ padding: '10px 10px 0' }}>
                                            <Row gutter={24}>
                                                <Col span={8}>
                                                    <h3>
                                                        已超期望率
                                                        <Button
                                                            size="small"
                                                            onClick={this.showModalOne}
                                                            style={{ float: 'right' }}>
                                                            查看全部
                                                        </Button>
                                                    </h3>
                                                </Col>
                                                <Col span={8}>
                                                    <h3>
                                                        执行成功率
                                                        <Button
                                                            size="small"
                                                            onClick={this.showModalTwo}
                                                            style={{ float: 'right' }}>
                                                            查看全部
                                                        </Button>
                                                    </h3>
                                                </Col>
                                                <Col span={8}>
                                                    <h3>
                                                        任务完成率
                                                        <Button
                                                            size="small"
                                                            onClick={this.showModalThree}
                                                            style={{ float: 'right' }}>
                                                            查看全部
                                                        </Button>
                                                    </h3>
                                                </Col>
                                            </Row>
                                        </div>

                                        <div
                                            style={{
                                                display: this.state.dspActiveKeys === 'lt' ? 'block' : 'none',
                                                marginTop: '10px',
                                                padding: '0 10px 10px',
                                            }}>
                                            <Row gutter={24}>
                                                <Col span={8} style={{ borderRight: '1px dashed #e8e8e8' }}>
                                                    <Row>
                                                        <h4>最低TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.noGoalsOtherRateslt900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            pagination={false}
                                                            style={{ border: 'none' }}
                                                            size="small">
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderNoGoalsRatesBtm5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                    <Row style={{ marginTop: '20px' }}>
                                                        <h4>最高TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.noGoalsOtherRatesTop5lt900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderNoGoalsRatesTop5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                </Col>
                                                <Col span={8} style={{ borderRight: '1px dashed #e8e8e8' }}>
                                                    <Row>
                                                        <h4>最低TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.execSucceedOtherRateslt900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderExecSucceedRatesBtm5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                    <Row style={{ marginTop: '20px' }}>
                                                        <h4>最高TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.execSucceedOtherRatesTop5lt900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderExecSucceedRatesTop5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                </Col>
                                                <Col span={8}>
                                                    <Row>
                                                        <h4>最低TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.completeOtherRateslt900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderCompleteRatesBtm5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                    <Row style={{ marginTop: '20px' }}>
                                                        <h4>最高TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.completeOtherRatesTop5lt900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderCompleteRatesBtm5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div
                                            style={{
                                                display: this.state.dspActiveKeys === 'get' ? 'block' : 'none',
                                                marginTop: '10px',
                                                padding: '0 10px 10px',
                                            }}>
                                            <Row gutter={24}>
                                                <Col span={8} style={{ borderRight: '1px dashed #e8e8e8' }}>
                                                    <Row>
                                                        <h4>最低TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.noGoalsOtherRatesget900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderNoGoalsRatesBtm5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                    <Row style={{ marginTop: '20px' }}>
                                                        <h4>最高TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.noGoalsOtherRatesTop5get900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderNoGoalsRatesTop5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                </Col>
                                                <Col span={8} style={{ borderRight: '1px dashed #e8e8e8' }}>
                                                    <Row>
                                                        <h4>最低TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.execSucceedOtherRatesget900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderExecSucceedRatesBtm5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                    <Row style={{ marginTop: '20px' }}>
                                                        <h4>最高TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.execSucceedOtherRatesTop5get900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderExecSucceedRatesTop5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                </Col>
                                                <Col span={8}>
                                                    <Row>
                                                        <h4>最低TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.completeOtherRatesget900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderCompleteRatesBtm5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                    <Row style={{ marginTop: '20px' }}>
                                                        <h4>最高TOP5</h4>
                                                        <Table
                                                            dataSource={
                                                                todyTaskData.execInfos
                                                                    ? todyTaskData.execInfos.completeOtherRatesTop5get900.slice(
                                                                            0,
                                                                            5,
                                                                        )
                                                                    : []
                                                            }
                                                            size="small"
                                                            pagination={false}>
                                                            <Column
                                                                title="任务ID"
                                                                dataIndex="taskId"
                                                                key="taskId"
                                                                sorter={false}
                                                                render={this.renderTaskId}
                                                            />

                                                            <Column
                                                                title="比率"
                                                                dataIndex="rate"
                                                                key="rate"
                                                                sorter={false}
                                                                render={this.renderCompleteRatesBtm5lt900}
                                                            />
                                                        </Table>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div> */}



                                    {/* 间隔 */}

                                    <div
                                        id="left_bottom"
                                        style={{
                                            marginTop: '30px',
                                            boxShadow: '1px 2px 15px #ccc',
                                            borderRadius: '5px',
                                            overflow: 'hidden',
                                        }}>
                                        <h2>代理监控
                                           <div style={{ right: '30px', position: 'absolute', top: '2px'}}>
                                           </div>
                                            <Icon
                                                    type="reload"
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontSize: '20px',
                                                        color: '#fff',
                                                        fontWeight: 'bold',
                                                        float: 'right',
                                                        marginTop: '4px',
                                                    }}
                                                    onClick={this.props.getAgentMonitorData}
                                            />
                                        </h2>
                                        <Table
                                            dataSource={AgentMinotor}
                                            pagination={false}
                                            size="small"
                                            scroll={{ y: 200 }}>
                                            <Column
                                                title="代理商"
                                                dataIndex="agent"
                                                key="agent"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />

                                            <Column
                                                title="IP总数"
                                                dataIndex="sum"
                                                key="sum"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />
                                            <Column
                                                title="IP重复率"
                                                dataIndex="ipRepetitionRate"
                                                key="ipRepetitionRate"
                                                sorter={false}
                                                width="20%"
                                                render={this.renderAgentToFixed}
                                            />
                                            <Column
                                                title="失败率"
                                                dataIndex="errorRate"
                                                key="errorRate"
                                                sorter={false}
                                                width="20%"
                                                render={this.renderAgentMinotorErrorRate}
                                            />
                                            <Column
                                                title="最大分配量"
                                                dataIndex="autoAssignMaxNum"
                                                key="autoAssignMaxNum"
                                                sorter={false}
                                                width="20%"
                                                render={text => {
                                                    return text;
                                                }}
                                            />
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={9}>
                            <div
                                id="center"
                                style={{ boxShadow: '1px 2px 15px #ccc', borderRadius: '5px', overflow: 'hidden' }}>
                                <Spin tip="Loading..." size="large" spinning={taskLoading}>
                                    <h2 style={{ height: '47px' ,position:'relative'}}>
                                        任务实时监控
                                        <div style={{ right: '30px',position:'absolute',top:'2px'}}>
                                            <div
                                                className={this.state.taskSource === 'normal' ? 'active radio' : 'radio'}
                                                style={{ right: '89px', borderRadius: '4px 0 0 4px' }}
                                                onClick={this.ClicksNormal}>
                                                普通任务
                                            </div>
                                            <div
                                                className={this.state.taskSource === 'accurateOperations' ? 'active radio' : 'radio'}
                                                style={{ right: '20px', borderRadius: '0 4px 4px 0' }}
                                                onClick={this.ClicksAccurateOperations}>
                                                精投任务
                                            </div>
                                            <div
                                                className={this.state.taskSource === 'applunch' ? 'active radio' : 'radio'}
                                                style={{ right: '158px', borderRadius: '0 4px 4px 0' }}
                                                onClick={this.ApplaunchAndCombine}>
                                                拉起任务
                                            </div>
                                        </div>
                                        <Icon
                                            className='reload'
                                            type="reload"
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '20px',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                float: 'right',
                                                marginTop: '4px',
                                            }}
                                            onClick={this.reloadTaskData}
                                        />
                                    </h2>


                                    <Table
                                        dataSource={this.state.taskSource === 'normal' ? TaskMinotor.normal : this.state.taskSource==='accurateOperations' ?  TaskMinotor.accurateOperations : TaskMinotor.applunch}
                                        pagination={false}
                                        scroll={{ y: 1405 }}
                                        rowClassName={this.renderTaskMinotorTr}
                                        size="small">
                                        <Column
                                            title="任务ID"
                                            dataIndex="taskId"
                                            key="taskId"
                                            sorter={false}
                                            width="8%"
                                            render={this.renderTaskIds}
                                        />

                                        <Column
                                            title="分配数"
                                            dataIndex="taskAssignNum"
                                            key="taskAssignNum"
                                            //sorter={false}
                                            width="10%"
                                            sorter={ (a, b) => a.taskAssignNum - b.taskAssignNum}
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="实际分配数"
                                            dataIndex="assignActually"
                                            key="assignActually"
                                            sorter={ (a, b) => a.assignActually - b.assignActually}
                                            width="12%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="成功数"
                                            dataIndex="successCount"
                                            key="successCount"
                                            sorter={ (a, b) => a.successCount - b.successCount}
                                            width="10%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="失败数"
                                            dataIndex="reassignErrorCount"
                                            key="reassignErrorCount"
                                            sorter={ (a, b) => a.reassignErrorCount - b.reassignErrorCount}
                                            width="10%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="任务丢弃"
                                            dataIndex="dropNum"
                                            key="dropNum"
                                            sorter={ (a, b) => a.dropNum - b.dropNum}
                                            width="10%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="没有代理"
                                            dataIndex="noProxyCount"
                                            key="noProxyCount"
                                            sorter={ (a, b) => a.noProxyCount - b.noProxyCount}
                                            width="10%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="没有素材"
                                            dataIndex="noDataCount"
                                            key="noDataCount"
                                            sorter={ (a, b) => a.noDataCount - b.noDataCount}
                                            width="10%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="无设备信息"
                                            dataIndex="noDeviceCount"
                                            key="noDeviceCount"
                                            sorter={ (a, b) => a.noDeviceCount - b.noDeviceCount}
                                            width="12%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="系统错误"
                                            dataIndex="systemErrorCount"
                                            key="systemErrorCount"
                                            sorter={ (a, b) => a.systemErrorCount - b.systemErrorCount}
                                            width="13%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                    </Table>
                                </Spin>
                            </div>
                        </Col>
                        <Col span={7}>
                            <Spin tip="Loading..." size="large" spinning={serveLoading}>
                                <div
                                    id="right"
                                    style={{ boxShadow: '1px 2px 15px #ccc', borderRadius: '5px', overflow: 'hidden' }}>
                                    <h2 style={{ height: '47px' ,position:'relative'}}>
                                        服务监控
                                        <Icon
                                            className='reload'
                                            type="reload"
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '20px',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                float: 'right',
                                                marginTop: '4px',
                                            }}
                                            onClick={this.reloadServeData}
                                        />
                                    </h2>
                                    <Row style={{ marginTop: '10px', fontSize: '18px', paddingLeft: '20px' }}>
                                        <Col span={12}><h3 style={{fontSize: '18px'}}>Sever</h3></Col>
                                        {/* <Col span={12}><Button type="danger" onClick={this.clearList}>清空队列</Button></Col> */}
                                    </Row>
                                    <Table
                                        dataSource={ServiceMinotor.Server}
                                        pagination={false}
                                        size="small"
                                        style={{ marginTop: '10px' }}>
                                        <Column
                                            title="点击客户端数"
                                            dataIndex="clickWorkerNumber"
                                            key="clickWorkerNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="曝光客户端数"
                                            dataIndex="evWorkerNumber"
                                            key="evWorkerNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="通用客户端数"
                                            dataIndex="normalWorkerNumber"
                                            key="normalWorkerNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                         <Column
                                            title="状态"
                                            dataIndex="status"
                                            key="status"
                                            sorter={false}
                                            width="10%"
                                            render={this.renderServiceStatus}
                                        />
                                        {/* <Column
                                            title="定向点击客户端数"
                                            dataIndex="appointClickWorkerNumber"
                                            key="appointClickWorkerNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="定向曝光客户端数"
                                            dataIndex="appointEvWorkerNumber"
                                            key="appointEvWorkerNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="定向客户端数"
                                            dataIndex="normalAppointWorkerNumber"
                                            key="normalAppointWorkerNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        /> */}
                                    </Table>
                                    <Table
                                        dataSource={ServiceMinotor.Server}
                                        pagination={false}
                                        size="small"
                                        style={{ marginTop: '10px' }}>
                                        <Column
                                            title="点击阻塞任务数"
                                            dataIndex="blockingClickTaskNumber"
                                            key="blockingClickTaskNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="曝光阻塞任务数"
                                            dataIndex="blockingEvTaskNumber"
                                            key="blockingEvTaskNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="丢弃点击任务数"
                                            dataIndex="discardClickTaskNumber"
                                            key="discardClickTaskNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="丢弃曝光任务数"
                                            dataIndex="discardEvTaskNumber"
                                            key="discardEvTaskNumber"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                    </Table>
                                    <Row style={{ marginTop: '10px', fontSize: '18px', paddingLeft: '20px' }}>
                                        <Col span={12}><h3 style={{fontSize: '18px'}}>appServer</h3></Col>
                                        {/* <Col span={12}><Button type="danger" onClick={this.clearList}>清空队列</Button></Col> */}
                                    </Row>
                                    <Table
                                        dataSource={ServiceMinotor.appServer}
                                        pagination={false}
                                        size="small"
                                        style={{ marginTop: '10px' }}>
                                        <Column
                                            title="总客户端数量"
                                            dataIndex="totalClientNum"
                                            key="totalClientNum"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="安卓成功数"
                                            dataIndex="successCount"
                                            key="successCount"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="ios成功数"
                                            dataIndex="successIosCount"
                                            key="successIosCount"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="状态"
                                            dataIndex="status"
                                            key="status"
                                            sorter={false}
                                            width="10%"
                                            render={this.renderServiceStatus}
                                        />
                                    </Table>
                                    <Table
                                        dataSource={ServiceMinotor.appServer}
                                        pagination={false}
                                        size="small"
                                        style={{ marginTop: '10px' }}>
                                        <Column
                                            title="安卓在线数"
                                            dataIndex="onlineClientNum"
                                            key="onlineClientNum"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="安卓离线数量"
                                            dataIndex="offlineClientNum"
                                            key="offlineClientNum"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="ios在线数量"
                                            dataIndex="onlineIosClientNum"
                                            key="onlineIosClientNum"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="ios离线数量"
                                            dataIndex="offlineIosClientNum"
                                            key="offlineIosClientNum"
                                            sorter={false}
                                            width="12.5%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                    </Table>
                                    <Row style={{ marginTop: '10px', fontSize: '18px', paddingLeft: '20px' }}>
                                        <Col span={12}><h3 style={{fontSize: '18px'}}>任务队列</h3></Col>
                                        <Col span={6}><Button type="danger" onClick={this.clearList}>清空所有</Button></Col>
                                    </Row>
                                    <Table
                                        dataSource={ServiceMinotor.taskQueues}
                                        pagination={false}
                                        scroll={{ y: 1193 }}
                                        size="small"
                                        style={{ marginTop: '10px' }}>
                                        <Column
                                            title="任务分组"
                                            dataIndex="group"
                                            key="group"
                                            sorter={false}
                                            width="20%"
                                            render={text => {
                                                return text;
                                            }}
                                        />

                                        <Column
                                            title="队列名"
                                            dataIndex="queueName"
                                            key="queueName"
                                            sorter={false}
                                            width="15%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="任务数量"
                                            dataIndex="queueNum"
                                            key="queueNum"
                                            sorter={false}
                                            width="15%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="操作"
                                            dataIndex="ope"
                                            key="ope"
                                            sorter={false}
                                            width="15%"
                                            render={(text,record) => {
                                               return(<Button type="danger" onClick={() => this.clearOneList(record)}>清空队列</Button>) 
                                            }}
                                        />
                                    </Table>
                                    <h3 style={{ marginTop: '10px', fontSize: '18px', paddingLeft: '20px' }}>Client</h3>
                                    <Table
                                        dataSource={ServiceMinotor.Workers}
                                        pagination={false}
                                        scroll={{ y: 1193 }}
                                        size="small"
                                        style={{ marginTop: '10px' }}>
                                        <Column
                                            title="机器IP"
                                            dataIndex="localIp"
                                            key="localIp"
                                            sorter={false}
                                            width="20%"
                                            render={text => {
                                                return text;
                                            }}
                                        />

                                        <Column
                                            title="并发数"
                                            dataIndex="taskParallel"
                                            key="taskParallel"
                                            sorter={ (a, b) => a.taskParallel - b.taskParallel}
                                            width="15%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="点击并发度"
                                            dataIndex="clickTaskParallel"
                                            key="clickTaskParallel"
                                            sorter={ (a, b) => a.clickTaskParallel - b.clickTaskParallel}
                                            width="15%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="曝光并发度"
                                            dataIndex="evTaskParallel"
                                            key="evTaskParallel"
                                            sorter={ (a, b) => a.evTaskParallel - b.evTaskParallel}
                                            width="15%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="处理任务数"
                                            dataIndex="processTaskNum"
                                            key="processTaskNum"
                                            width="20%"
                                            sorter={ (a, b) => a.processTaskNum - b.processTaskNum}
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="阻塞任务数"
                                            dataIndex="threadPoolSize"
                                            key="threadPoolSize"
                                            sorter={ (a, b) => a.threadPoolSize - b.threadPoolSize}
                                            width="15%"
                                            render={text => {
                                                return text;
                                            }}
                                        />
                                        <Column
                                            title="类型"
                                            dataIndex="workerCategory"
                                            key="workerCategory"
                                            sorter={false}
                                            width="15%"
                                            render={text => {
                                                let category = '';
                                                switch (text) {
                                                    case 'NORMAL':
                                                        category = '通用';
                                                        break;
                                                    case 'EV':
                                                        category = '曝光';
                                                        break;
                                                    case 'CLICK':
                                                        category = '点击';
                                                        break;
                                                    case 'NORMAL_APPOINT':
                                                        category = '定向通用';
                                                        break;
                                                    case 'APPOINT_CLICK':
                                                        category = '定向点击';
                                                        break;
                                                    case 'APPOINT_EV':
                                                        category = '定向曝光';
                                                        break;
                                                };
                                                return <span>{category}</span>;
                                            }}
                                        />
                                        <Column
                                            title="状态"
                                            dataIndex="status"
                                            key="status"
                                            sorter={false}
                                            width="15%"
                                            render={this.renderServiceStatus}
                                        />
                                    </Table>
                                </div>
                            </Spin>
                        </Col>
                    </Row>
                </div>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.index.ListStatus.loading,
    indexList: state.index.IndexList,
    todyTaskData: state.index.TodyTask,
    PhoneAgentConnInfo: state.index.PhoneAgentConnInfo,
    NomalAgentConnInfo: state.index.NomalAgentConnInfo,
    AgentMinotor: state.index.AgentMinotor,
    TaskMinotor: state.index.TaskMinotor,
    ServiceMinotor: state.index.ServiceMinotor,
    taskLoading: state.index.TaskStatus.loading,
    serveLoading: state.index.TaskStatus.serveLoading,
    discardMinotor: state.index.discardMinotor,
    todayTaskResult: state.index.todayTaskResult,
});

const mapDispatchToProps = dispatch => ({
    // getIndexList: prarms => dispatch(getIndexList(prarms)),
    getTodyTaskData: () => dispatch(getTodyTaskData()),
    getPhoneAgentConnData: () => dispatch(getPhoneAgentConnInfo()),
    getNomalAgentConnData: () => dispatch(getNomalAgentConnInfo()),
    getAgentMonitorData: () => dispatch(getAgentMonitorData()),
    getTaskMonitorData: () => dispatch(getTaskMonitorData()),
    getServiceMonitorData: () => dispatch(getServiceMonitorData()),
    clearListAction: () => dispatch(clearListAction()),
    clearOneListAction: (group,queueName) => dispatch(clearOneListAction(group,queueName)),
    getDiscardList: () => dispatch(getDiscardList()),
    getTaskExcuteResult: ()=>  dispatch(getTaskExcuteResult()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskMessageList);



// WEBPACK FOOTER //
// ./pages/index/index.js